import * as Yup from "yup";

export const validationSchema = Yup.object().shape({
  buyerName: Yup.string().required("Customer name is required"),
  buyerContact: Yup.string().required("Customer phone number is required"),
  buyerEmail: Yup.string()
    .required("Customer email is required")
    .email("Invalid email address"),
  buyerAddress: Yup.string().required("Customer address is required"),
  buyerPanCardId: Yup.string()
    .required("Customer PAN Card is required")
    // pan card should be 10 characters long exactly
    .min(10, "PAN Card should be 10 characters long exactly")
    .max(10, "PAN Card should be 10 characters long exactly"),

  buyerAadharCardId: Yup.string()
    .required("Customer Aadhar Card is required")
    // aadhar card should be 12 characters long exactly
    .min(12, "Aadhar Card should be 12 characters long exactly")
    .max(12, "Aadhar Card should be 12 characters long exactly"),
  buyerAddressProofTypeOfDocument: Yup.string().required(
    "Customer Address Proof is required"
  ),
  buyerPanCardFile: Yup.mixed().required("Customer PAN Card File is required"),
  buyerAadharCardFile: Yup.mixed().required(
    "Customer Aadhar Card File is required"
  ),
  buyerAddressProofFile: Yup.mixed().required(
    "Customer Address Proof File is required"
  ),
});
